const resources = {
    overview: 'Overview'
};

export default function getResource(label) {
    return resources[label];
}
